import { render, staticRenderFns } from "./AssignmentOffer.vue?vue&type=template&id=f8e0ebc8&scoped=true&"
import script from "./AssignmentOffer.vue?vue&type=script&lang=js&"
export * from "./AssignmentOffer.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentOffer.vue?vue&type=style&index=0&id=f8e0ebc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e0ebc8",
  null
  
)

export default component.exports